import { render } from "./StreamsManageSettingsBackup.vue?vue&type=template&id=ae735e80&scoped=true"
import script from "./StreamsManageSettingsBackup.vue?vue&type=script&lang=js"
export * from "./StreamsManageSettingsBackup.vue?vue&type=script&lang=js"

import "./StreamsManageSettingsBackup.vue?vue&type=style&index=0&id=ae735e80&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae735e80"]])

export default __exports__